import { render, staticRenderFns } from "./MissionProfilePatients.vue?vue&type=template&id=71ec9566&scoped=true&"
import script from "./MissionProfilePatients.vue?vue&type=script&lang=js&"
export * from "./MissionProfilePatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec9566",
  null
  
)

export default component.exports